import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import SwiperCore, { Navigation, Pagination, EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { lang, img_url, gotoURL } from '../lang'
import ThemeContext from '../../context/ThemeContext';
import api from '../api'

SwiperCore.use([Navigation, Pagination, EffectFade]);
export default function Slide({article,classes}) {
    const [images, setImages] = useState([]);
    const { language, page, init } = useContext(ThemeContext);
    SwiperCore.use([Autoplay]); // start autoplay

    useEffect(()=>{
        const fetchInit = async () =>{
            try {
                let language = localStorage.getItem("lang");
                let article_id = 1;
                if(language===null){
                    language = "th";
                    localStorage.setItem("lang","th");
                }
                if(language==="en"){
                    article_id = 2;
                } 
              const response = await api.get('/gallery/'+article_id);
              setImages(response.data.results);
            } catch (err) {
                if(err.response){
                    //Not in 202 response range
                    console.log(err.response.data);
                    console.log(err.response.headers);
                    console.log(err.response.status);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
        }
        fetchInit();
    },[article,language]);

    return (
        <div className={classes["slide-container"]}>
            <Swiper
                effect={'fade'}
                speed={900}
                autoplay={{delay: 3000}} 
                navigation={true}
                pagination={{clickable: true, centeredSlides: true}}
                // modules={[EffectFade,Pagination]}
                modules={[EffectFade, Navigation, Pagination]}
            >
                {images.map((item, index) => (
                    <SwiperSlide className={classes["swiper-slide"]} key={index}>
                        <div className={classes["card"]}>
                            <a href={item.link}>
                            <img src={img_url + item.url} alt={lang(item.name_th,item.name_en)}/>
                            </a>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}
